<template>
  <div>
    <div v-if="state < 2 && !user">
      <div v-if="clientState < 2">
        {{ defaultPosition | positionToString }}
        <br />
        <button
          v-if="clientState == 1"
          class="button is-small is-info mt-2"
          v-on:click="sitHere(defaultPosition)"
        >SIT</button>
      </div>
      <div v-if="clientState == 2">{{ clientPosition | positionToString }}</div>
    </div>
    <div v-if="user">
      <div v-if="emoji" class="animate__animated animate__zoomIn" 
        style="position: absolute;">
        <div v-if="isTop" class="top-emoji">{{emoji}}</div>
        <div v-else class="side-emoji">{{emoji}}</div>
      </div>
      <div style="line-height: 1.25em; 
      padding-top: 4px;">
        {{ user.position | positionToString }}
        <span v-if="!isTop">
          <br />
        </span>
        {{ user.username }}
      </div>
      <div>
        <div v-if="state == 2 || state == 3" class="mt-3">
          <span v-for="i in user.hand.length" v-bind:key="rand() + i">
            <span
              class="game-card upper back"
              v-bind:class="{
              upper: isTop,
              side: !isTop,
            }"
            ></span>
          </span>
        </div>
        <div v-if="state == 4">
          <span v-for="card in user.hand" v-bind:key="rand() + card">
            <div
              class="side-card lower"
              v-bind:class="{ 'has-text-danger': card.indexOf('H') > 0 || card.indexOf('D') > 0, }"
            >
              {{ card | getNumber }}
              <br />
              {{ card | getSuit }}
            </div>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import socketStore from "@/service/socketStore";

export default {
  name: "SideComponent",
  props: {
    user: Object,
    state: Number,
    isTop: Boolean,
    defaultPosition: Number,
    clientPosition: Number,
    clientState: Number,
    emoji: String,
  },
  methods: {
    rand() {
      return Math.random().toString(36).substring(7);
    },
    sitHere() {
      socketStore.emit("set_position", this.defaultPosition);
    },
  },
};
</script>

<style>
.side-emoji {
  margin-top: 8rem;
  box-shadow: 0px 2px 3px grey;
  background: white;
  border-radius: 50%;
  height: 70px;
  width: 70px;
  font-size: 3rem;
}
.top-emoji {
  margin-left: 10.5rem;
  background: white;
  border-radius: 50%;
  height: 70px;
  width: 70px;
  box-shadow: 0px 2px 3px grey;
  margin-top: 1rem;
  font-size: 3rem;
}
</style>